import React from "react";
import {Switch} from "react-router-dom";
import PatientRoutes from "./Roles/Patient/PatientRoutes";
import MedCenterRoutes from "./Roles/MedCenter/MedCenterRoutes";
import OrganizationRoutes from "./Roles/Organization/OrganizationRoutes";
import SystemManagerRoutes from "./Roles/SystemManager/SystemManagerRoutes";
import AssistantCabinetRoutes from "./Roles/Assistant/Cabinet/AssistantCabinetRoutes";
import AssistantCarRoutes from "./Roles/Assistant/Car/AssistantCarRoutes";
import {GeneralRoutes} from "./routes/routes.general";
import VerificationCenterRoutes from "./Roles/VereficationCenter/VereficationCenterRoutes";

/**
 * Роутинг.
 * Если пользователь авторизован,то на основе номера роли, функция возвращает соответствующие этому номеру роуты.
 * Если пользователь не авторизован, функция возвращает общие роуты.
 * @constructor
 * @param {boolean} isAuthenticated -
 * @param {number || string} roleId - id роли
 */
export const useRoutes = (isAuthenticated, roleId) => {

    if (isAuthenticated) {
        switch (roleId) {
            case 2:
                return <SystemManagerRoutes/>;
            case 3:
                return <OrganizationRoutes/>;
            case 4:
                return <MedCenterRoutes/>;
            case 5:
                return <VerificationCenterRoutes/>;
            case 7:
                return <PatientRoutes/>;
            case 9:
                return <AssistantCabinetRoutes/>;
            case 10:
                return <AssistantCarRoutes/>;
            default:
                return <></>;
        }
    }
    return (
        <Switch>
            <GeneralRoutes/>
        </Switch>
    );
};

